"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenuController = exports.ExportMenuControllerImpl = void 0;
var tslib_1 = require("tslib");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var export_notification_1 = require("../export.notification/export.notification");
var export_notification_ctrl_1 = require("../export.notification/export.notification.ctrl");
var export_notification_style_1 = require("../export.notification/export.notification.style");
var ReportMaker_1 = require("../report/ReportMaker");
var ExportMenuControllerImpl = /** @class */ (function () {
    function ExportMenuControllerImpl() {
    }
    ExportMenuControllerImpl.prototype.hasOCalcForm = function (collectionSummaries) {
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var summary = collectionSummaries_1[_i];
            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null) {
                return true;
            }
        }
        return false;
    };
    ExportMenuControllerImpl.prototype.hasSPIDACalcForm = function (collectionSummaries) {
        for (var _i = 0, collectionSummaries_2 = collectionSummaries; _i < collectionSummaries_2.length; _i++) {
            var summary = collectionSummaries_2[_i];
            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null) {
                return true;
            }
        }
        return false;
    };
    ExportMenuControllerImpl.prototype.hasPoleforeman = function (collectionSummaries) {
        var _a;
        for (var _i = 0, collectionSummaries_3 = collectionSummaries; _i < collectionSummaries_3.length; _i++) {
            var summary = collectionSummaries_3[_i];
            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.poleforeman) {
                return true;
            }
        }
        return false;
    };
    ExportMenuControllerImpl.prototype.hasIkePoleForeman = function (collectionSummaries) {
        var _a;
        for (var _i = 0, collectionSummaries_4 = collectionSummaries; _i < collectionSummaries_4.length; _i++) {
            var summary = collectionSummaries_4[_i];
            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) {
                return true;
            }
        }
        return false;
    };
    ExportMenuControllerImpl.prototype.exportKML = function () {
        var selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.kml(selectorsByTag)
            .then(function (result) {
            if (result == null) {
                return;
            }
            if (result.notifications != null && result.notifications.length > 0) {
                notification_service_1.NotificationService.warn({ key: i18n_1.T.EXPORT_NOT_EVERYTHING_EXPORTED });
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    };
    ExportMenuControllerImpl.prototype.exportExcel = function () {
        var selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.excel(selectorsByTag)
            .then(function (result) {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    };
    ExportMenuControllerImpl.prototype.exportImportableExcel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.Services.Export.importableExcel(this.getSelectorsByTag())];
                    case 1:
                        result = _a.sent();
                        if (result == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.downloadExportResult(result)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportJSON = function () {
        var selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.json(selectorsByTag)
            .then(function (result) {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    };
    /**
     * Creates a PDF report of collections and downloads it
     * @param type The type of report to export
     */
    ExportMenuControllerImpl.prototype.exportReport = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var revisions, collectionModels;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        revisions = page_state_1.CurrentState.Tag.collections.map(function (summary) { return summary.revision; });
                        return [4 /*yield*/, Promise.all(revisions.map(function (revision) { return store_1.AppStore.Collection.fetch(revision); }))];
                    case 1:
                        collectionModels = _a.sent();
                        return [2 /*return*/, ReportMaker_1.PDFReportMaker.makeReport(type, collectionModels)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportOCalc = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectorsByTag, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectorsByTag = this.getSelectorsByTag(function (summary) {
                            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                            return formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null;
                        });
                        return [4 /*yield*/, services_1.Services.Export.ocalc(selectorsByTag)];
                    case 1:
                        response = _a.sent();
                        if (response == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.downloadExportResult(response)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportSPIDACalc = function (noPhotos) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectorsByTag, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectorsByTag = this.getSelectorsByTag(function (summary) {
                            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                            return formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null;
                        });
                        return [4 /*yield*/, services_1.Services.Export.spidacalc(selectorsByTag, noPhotos)];
                    case 1:
                        response = _a.sent();
                        if (response == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.downloadExportResult(response)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportPoleforeman = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectorsByTag, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectorsByTag = this.getSelectorsByTag(function (summary) {
                            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                            return formSummary != null && formSummary.metadata != null && formSummary.metadata.poleforeman != null;
                        });
                        return [4 /*yield*/, services_1.Services.Export.poleforeman(selectorsByTag)];
                    case 1:
                        response = _a.sent();
                        if (response == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.downloadExportResult(response)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportIkePoleForeman = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectorsByTag, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectorsByTag = this.getSelectorsByTag(function (summary) {
                            var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                            return formSummary != null && formSummary.metadata != null && formSummary.metadata.ikePoleForeman != null;
                        });
                        return [4 /*yield*/, services_1.Services.Export.ikePoleForeman(selectorsByTag)];
                    case 1:
                        response = _a.sent();
                        if (response == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.downloadExportResult(response)];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.exportImageZip = function () {
        var selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.imageZip(selectorsByTag)
            .then(function (result) {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    };
    ExportMenuControllerImpl.prototype.runExport = function (exportState, func) {
        return Promise.resolve()
            .then(function (_) { return exportState.setExporting(true); })
            .then(function (_) { return func(); })
            .catch(function (_) { return notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL }); })
            .then(function (_) { return exportState.setExporting(false); });
    };
    ExportMenuControllerImpl.prototype.downloadExportResult = function (response) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exportNotificationCtrl, revisionsToFetch, collectionPromises, collections;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exportNotificationCtrl = new export_notification_ctrl_1.ExportNotificationCtrl(response.notifications);
                        revisionsToFetch = exportNotificationCtrl.getRevisions();
                        if (revisionsToFetch.length === 0) {
                            services_1.Services.Download.download(response.url);
                            return [2 /*return*/, null];
                        }
                        collectionPromises = revisionsToFetch.map(function (revision) { return store_1.AppStore.Collection.fetch(revision); });
                        return [4 /*yield*/, Promise.all(collectionPromises)];
                    case 1:
                        collections = _a.sent();
                        return [4 /*yield*/, this.showExportNotifications(exportNotificationCtrl, collections)];
                    case 2:
                        _a.sent();
                        if (!exportNotificationCtrl.errors && response.url != null) {
                            services_1.Services.Download.download(response.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportMenuControllerImpl.prototype.showExportNotifications = function (exportNotificationCtrl, collections) {
        exportNotificationCtrl.setCollections(collections);
        var modalContext = {
            title: export_notification_1.ExportNotificationTitle.view(exportNotificationCtrl),
            content: export_notification_1.ExportNotificationContent.view(exportNotificationCtrl),
            hasCancel: false,
            className: export_notification_style_1.CSS.modal
        };
        return modal_service_1.ModalService.open(modalContext);
    };
    ExportMenuControllerImpl.prototype.getSelectorsByTag = function (filter) {
        if (filter === void 0) { filter = function () { return true; }; }
        var selectorsByTag = {};
        for (var _i = 0, _a = page_state_1.CurrentState.Tag.collections; _i < _a.length; _i++) {
            var collectionSummary = _a[_i];
            if (filter(collectionSummary)) {
                var selector = { uuid: collectionSummary.uuid };
                var tagId = collectionSummary.tags[0];
                if (selectorsByTag[tagId]) {
                    selectorsByTag[tagId].push(selector);
                }
                else {
                    selectorsByTag[tagId] = [selector];
                }
            }
        }
        return selectorsByTag;
    };
    return ExportMenuControllerImpl;
}());
exports.ExportMenuControllerImpl = ExportMenuControllerImpl;
exports.ExportMenuController = new ExportMenuControllerImpl();
//# sourceMappingURL=export.menu.ctrl.js.map